import { User } from '../types';

/**
 * Whether the free public beta is running (REACT_APP_FREE_BETA=true, read at
 * build time). Mirrors the backend FREE_BETA flag (#195).
 */
export const isFreeBeta = (flag: string | undefined = process.env.REACT_APP_FREE_BETA): boolean =>
  flag?.trim() === 'true';

/**
 * Whether a user may take quizzes: always in the free beta, otherwise with
 * an active subscription or an unexpired trial.
 */
export const hasQuizAccess = (
  user: User | null,
  now: Date = new Date(),
  freeBeta: boolean = isFreeBeta()
): boolean => {
  if (!user) return false;
  if (freeBeta) return true;
  if (user.subscriptionStatus === 'active' && user.subscriptionEndDate &&
      new Date(user.subscriptionEndDate) > now) {
    return true;
  }
  return !!user.trialExpiry && new Date(user.trialExpiry) > now;
};
